import { render, staticRenderFns } from "./MenuHead.vue?vue&type=template&id=0166ec92&scoped=true"
import script from "./MenuHead.vue?vue&type=script&lang=js"
export * from "./MenuHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166ec92",
  null
  
)

export default component.exports